import instance from "../axios";
import { LoginResponse } from "../pages/login/types";
import { SignupResponse } from "../pages/signup/types";
import { UpdatePasswordPayloadType } from "../pages/update-password/types";
import * as endpoints from "./endpoints";

export const resetPasswordApi = (payload: any) => {
  delete instance.defaults.headers.common["Authorization"];
  return new Promise((resolve, reject) => {
    instance
      .post(endpoints.RESET_PASSWORD, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updatePasswordApi = (payload: UpdatePasswordPayloadType) => {
  delete instance.defaults.headers.common["Authorization"];
  return new Promise((resolve, reject) => {
    instance
      .post(endpoints.UPDATE_PASSWORD, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const loginUser = (payload: any) => {
  delete instance.defaults.headers.common["Authorization"];
  return new Promise<LoginResponse>((resolve, reject) => {
    instance
      .post(endpoints.LOGIN_API_PATH, payload)
      .then((response) => {
        const { data } = response.data;
        instance.defaults.headers.common["Authorization"] = `Bearer ${data}`;
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const registerUser = (payload: any) => {
  delete instance.defaults.headers.common["Authorization"];
  return new Promise<SignupResponse>((resolve, reject) => {
    instance
      .post(endpoints.REGISTER_API_PATH, payload)
      .then((response) => {
        const { data } = response.data;
        instance.defaults.headers.common["Authorization"] =
          `Bearer ${data.token}`;
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAllBreeds = (specie: number) => {
  let path = endpoints.GET_ALL_BREEDS_API_PATH.replace(
    "{speciesId}",
    specie.toString()
  );
  return instance.get(path);
};

export const getAllGenders = () => {
  let path = endpoints.GET_ALL_GENDERS_API_PATH;
  return instance.get(path);
};

export const getAllSpecies = () => {
  let path = endpoints.GET_ALL_SPECIES_API_PATH;
  return instance.get(path);
};

export const addClient = (payload: any) => {
  let path = endpoints.ADD_CLIENT_API_PATH;
  return instance.post(path, payload);
};

export const getClients = (search: string) => {
  let path = endpoints.GET_ALL_CLIENTS_API_PATH.replace("{search}", search);
  return instance.get(path);
};

export const addPet = (payload: any) => {
  let path = endpoints.ADD_PET_API_PATH;
  return instance.post(path, payload);
};

export const findPets = (clientId: string) => {
  let path = endpoints.FIND_PETS_API_PATH;
  return instance.post(path, { clientId });
};

export const getAllAppointments = (provider?: any) => {
  let path = endpoints.GET_ALL_APPOINTMENTS_PATH(provider);
  return instance.get(path);
};

export const getAllNotifyAppointments = (provider?: any) => {
  let path = endpoints.GET_ALL_NOTIFY_APPOINTMENTS_PATH(provider);
  return instance.get(path);
};

export const getAllAppointmentsTypes = () => {
  let path = endpoints.GET_ALL_APPOINTMENTS_TYPES_PATH;
  return instance.get(path);
};

export const getAllAppointmentsProviders = () => {
  let path = endpoints.GET_ALL_APPOINTMENTS_PROVIDERS_PATH;
  return instance.get(path);
};

export const getMoreAppointmentsSlots = (payload: any) => {
  let path = endpoints.GET_MORE_APPOINTMENTS_SLOTS_PATH;
  return instance.post(path, payload);
};

export const submitTimeSlotsRequest = (payload: any) => {
  let path = endpoints.SUBMIT_TIME_SLOTS_REQUEST_PATH;
  return instance.post(path, payload);
};

export const createAppointment = (payload: any) => {
  let path = endpoints.CREATE_APPOINTMENT_PATH;
  return instance.post(path, payload);
};

export const inviteUser = (payload: any) => {
  let path = endpoints.INVITE_PATH;
  return instance.post(path, payload);
};

// API's handlers for User APP
export const sendOtpForEmail = (payload: any) =>
  instance.post(endpoints.SEND_OTP_FOR_EMAIL_PATH, payload);

export const sendOtpForNumber = (payload: any) =>
  instance.post(endpoints.SEND_OTP_FOR_NUMBER_PATH, payload);

export const verifyEmailOtp = (payload: any) =>
  instance.post(endpoints.VERIFY_EMAIL_OTP_PATH, payload);

export const verifyNumberOtp = (payload: any) =>
  instance.post(endpoints.VERIFY_NUMBER_OTP_PATH, payload);

export const createUserPatient = (payload: any) =>
  instance.post(endpoints.CREATE_CLIENT_PATH, payload);

export const updatePatient = (payload: any) =>
  instance.put(endpoints.UPDATE_CLIENT, payload);

export const updateUserPatient = (payload: any) =>
  instance.put(endpoints.UPDATE_CLIENT_PATH, payload);

export const createUserPet = (payload: any) =>
  instance.post(endpoints.CREATE_PET_PATH, payload);

export const gettAllEmailUsers = (payload: any) =>
  instance.get(endpoints.GET_ALL_USERS_BY_EMAIL(payload));

export const gettAllNumberUsers = (payload: any) =>
  instance.get(endpoints.GET_ALL_USERS_BY_NUMBER(payload));

export const getAllUserSpecies = () => {
  let path = endpoints.GET_ALL_USER_SPECIES_API_PATH;
  return instance.get(path);
};

export const getAllUserBreeds = (specie: number) => {
  let path = endpoints.GET_ALL_USER_BREEDS_API_PATH.replace(
    "{speciesId}",
    specie?.toString()
  );
  return instance.get(path);
};

export const getAllUserGenders = () => {
  let path = endpoints.GET_ALL_USER_GENDERS_API_PATH;
  return instance.get(path);
};

export const findUserPets = (clientId: string) => {
  let path = endpoints.FIND_USER_PETS_API_PATH;
  return instance.post(path, { clientId });
};

export const getAllUserAppointmentsTypes = () => {
  let path = endpoints.GET_ALL_USER_APPOINTMENTS_TYPES_PATH;
  return instance.get(path);
};

export const getAllUserAppointments = () => {
  let path = endpoints.GET_ALL_USER_APPOINTMENTS_PATH;
  return instance.get(path);
};

export const submitUserTimeSlotsRequest = (payload: any) => {
  let path = endpoints.SUBMIT_USER_TIME_SLOTS_REQUEST_PATH;
  return instance.post(path, payload);
};

export const getMoreUserAppointmentsSlots = (payload: any) => {
  let path = endpoints.GET_MORE_USER_APPOINTMENTS_SLOTS_PATH;
  return instance.post(path, payload);
};

export const createUserAppointment = (payload: any) => {
  let path = endpoints.CREATE_USER_APPOINTMENT_PATH;
  return instance.post(path, payload);
};

export const logoutUser = () => {
  let path = endpoints.LOGUT_USER_PATH;
  return instance.post(path);
};

// Admin flow APIs callbacks
export const inviteUserFromAdmin = (payload: any) => {
  let path = endpoints.ADMIN_INVITE_PATH;
  return instance.post(path, payload);
};

export const fetchUsers = () => {
  let path = endpoints.GET_ALL_USERS_PATH;
  return instance.get(path);
};

export const updateAdminPasswordApi = (payload: any) => {
  delete instance.defaults.headers.common["Authorization"];
  return new Promise((resolve, reject) => {
    instance
      .post(endpoints.UPDATE_ADMIN_PASSWORD_PATH, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createBlockOff = (payload: any) => {
  let path = endpoints.CREATE_BLOCK_OFF_PATH;
  return instance.post(path, payload);
};

export const getAllBlocksOff = (payload: any) => {
  let path = endpoints.GET_ALL_BLOCKOFF_PATH;
  return instance.post(path, payload);
};

export const removeSingleBlocksOff = (payload: any) => {
  let path = endpoints.DELETE_SINGLE_BLOCKOFF_PATH;
  return instance.post(path, payload);
};

export const removeAllBlocksOffs = (payload: any) => {
  let path = endpoints.DELETE_ALL_BLOCKOFF_PATH;
  return instance.post(path, payload);
};

export const getValidRepeatIntervals = () => {
  let path = endpoints.REPEAT_INTERVAL_PATH;
  return instance.get(path);
};

export const getAllTravelClients = () => {
  let path = endpoints.GET_ALL_TRAVEL_CLIENTS_PATH;
  return instance.get(path);
}

export const attachTravelClient = (payload: any) => {
  let path = endpoints.ATTACH_TRAVEL_CLIENT_PATH;
  return instance.post(path, payload);
}

export const changeUserAccess = (payload: {
  email: string;
  status: "Accepted" | "Revoke";
}) => {
  let path = endpoints.CHANGE_USER_ACCESS_PATH;
  return instance.post(path, payload);
};

export const getAllReserveData = () => {
  let path = endpoints.GET_ALL_RESERVE_DATA_PATH;
  return instance.get(path);
};

export const getAllTimeAdjustments = () => {
  let path = endpoints.GET_ALL_TIME_ADJUSTMENTS_PATH;
  return instance.get(path);
};

export const createTimeAdjustment = (payload: any) => {
  let path = endpoints.CREATE_TIME_ADJUSTMENT_PATH;
  return instance.post(path, payload);
};

export const updateTimeAdjustment = (payload: any) => {
  let path = endpoints.UPDATE_TIME_ADJUSTMENT_PATH;
  return instance.put(path, payload);
};

export const getRuleset = () => {
  let path = endpoints.GET_RULESET_PATH;
  return instance.get(path);
};

export const updateRuleset = (payload: any) => {
  let path = endpoints.UPDATE_RULESET_PATH;
  return instance.put(path, payload);
};

export const sendNotification = (payload: any) => {
  let path = endpoints.SEND_NOTIFICATION_PATH;
  return instance.post(path, payload);
};

export const getAllProviderAppointments = () => {
  let path = endpoints.FETCH_PROVIDERS_APPOINTMENTS;
  return instance.post(path);
};

// Provider Schedules
export const getProviderSchedule = (providerId: string) =>
  instance.get(endpoints.GET_PROVIDER_SCHEDULE_PATH(providerId));

export const updateProviderSchedule = (providerId: string, payload: any) =>
  instance.put(endpoints.UPDATE_PROVIDER_SCHEDULE_PATH(providerId), payload);

// Reschedule Schedule
export const getRescheduleSchedules = () =>
  instance.get(endpoints.GET_RESCHEDULE_SCHEDULES_PATH);

export const createRescheduleSchedule = (payload: any) =>
  instance.post(endpoints.CREATE_RESCHEDULE_SCHEDULE_PATH, payload);

export const updateRescheduleSchedule = (id: number, payload: any) =>
  instance.put(endpoints.UPDATE_RESCHEDULE_SCHEDULE_PATH(id), payload);

export const deleteRescheduleSchedule = (id: number) =>
  instance.delete(endpoints.DELETE_RESCHEDULE_SCHEDULE_PATH(id));

export const runReschedule = (payload?: { dry_run?: boolean }) =>
  instance.post(endpoints.RUN_RESCHEDULE_PATH, payload || {});

export const getRescheduleLatestResult = () =>
  instance.get(endpoints.GET_RESCHEDULE_LATEST_RESULT_PATH);

export const getRescheduleData = (token: string) => {
  let path = endpoints.GET_RESCHEDULE_DATA(token);
  return instance.get(path);
};

export const confirmReschedule = (token: string) => {
  let path = endpoints.CONFIRM_RESCHEDULE_DATA(token);
  return instance.get(path);
};


export const cancelRescheduleNofity = (token: string) => {
  let path = endpoints.CANCEL_RESCHEDULE_NOTIFY(token);
  return instance.get(path);
};
